import { render, staticRenderFns } from "./Shareholders.vue?vue&type=template&id=e94dc9b0&scoped=true"
import script from "./Shareholders.vue?vue&type=script&lang=js"
export * from "./Shareholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94dc9b0",
  null
  
)

export default component.exports